import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-lightning-ceiling-fans',
  templateUrl: './icon-lightning-ceiling-fans.component.html',
  styleUrls: ['./icon-lightning-ceiling-fans.component.scss']
})
export class IconLightningCeilingFansComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
